import { gtcDebounce } from './gtc-utils.js';
const productCardImageSelector = '.product-card__image--primary';

/************************* *Content block  *************************/
class ContentBlock extends HTMLElement {
  constructor() {
    super();
  }
  connectedCallback() {

    this.dom = {
      container: this.querySelector('.gtc\\:content-block__media-container')
    };

    if (this.hasAttribute('match-product-image-height')) {
      this.init();
    }
  }

  init() {
    const productImage = this.parentElement.querySelector(productCardImageSelector);
    if (!productImage) {
      return;
    }

    const handleResize = gtcDebounce(() => {
      this.dom.container.style.minHeight = productImage.getBoundingClientRect().height + 'px';
    }, 10);
    window.addEventListener('resize', handleResize);
    this.dom.container.style.minHeight = productImage.getBoundingClientRect().height + 'px';
  }
}

if (!customElements.get('gtc-content-block')) {
  customElements.define('gtc-content-block', ContentBlock);
}
